import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Paste"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 15H13.3725L15.3075 13.0575L14.25 12L10.5 15.75L14.25 19.5L15.3075 18.4425L13.3725 16.5H19.5V22.5H21V16.5C21 15.6716 20.3284 15 19.5 15ZM12.5325 1.71751L17.7825 6.96751C17.9229 7.10905 18.0012 7.30066 18 7.50001V10.5H16.5V9.00001H12C11.1716 9.00001 10.5 8.32844 10.5 7.50001V3.00001H4.5V21H10.5V22.5H4.5C3.67157 22.5 3 21.8284 3 21V3.00001C3 2.17159 3.67157 1.50001 4.5 1.50001H12C12.1994 1.49886 12.391 1.57712 12.5325 1.71751ZM16.1925 7.50004L12 3.30754V7.50004H16.1925Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Paste.vue"]]);
